import React from 'react';
import PropTypes from 'prop-types';
import {geolocated} from 'react-geolocated';
import {connect} from 'react-redux';
import SightingLocation from "./SightingLocation";

class Demo extends React.Component {
  constructor(props, context) {
    super(props, context);

    this.state = {
      vizcodeId: this.props.vizcodeId,
      errors: {}
    };
  }

  sendNotification(vizcodeId, coords) {
    // console.log('vid ', vizcodeId);
    // console.log('lat ', coords.latitude);
    // console.log('lon ', coords.longitude);
    return(<SightingLocation coords={coords}/>);
  }

  render() {
    return !this.props.isGeolocationAvailable
      ? <div>Your browser does not support Geolocation</div>
      : !this.props.isGeolocationEnabled
        ? <div>Geolocation is not enabled</div>
        : this.props.coords
          ?this.sendNotification(this.state.vizcodeId, this.props.coords)
          : <div>Getting the location data&hellip; </div>;
  }
}

Demo.propTypes = {
  vizcodeId: PropTypes.string,
  coords: PropTypes.object,
  isGeolocationEnabled: PropTypes.oneOfType([PropTypes.bool, PropTypes.func ]),
  isGeolocationAvailable: PropTypes.oneOfType([PropTypes.bool, PropTypes.func ])
};

function mapStateToProps(state, ownProps) {
  const vizcodeId = ownProps.match.params.vizcode;
  return {
    vizcodeId: vizcodeId
  }
}

export default connect(mapStateToProps, )(geolocated({
  positionOptions: {
    enableHighAccuracy: false,
  },
  userDecisionTimeout: 5000,
})(Demo));



// WEBPACK FOOTER //
// ./src/components/sighting/SightingPage.js